import React from 'react';
import { Modal } from 'antd';
import "./modal.css"
import TranslateText from '../../resuableComponents/TranslateText';
const RbiGuideLineModal = ({ isOpen, setIsOpen }) => {
    const handleCancel = () => {
        setIsOpen(false);
    };
    return (
        <>
            <Modal
                centered
                open={isOpen}
                footer={null}
                onCancel={handleCancel}
            >
                <div className='rbi-guide-line-modal'>
                    <div className='title'>
                        <TranslateText label={"RBI_GUIDELINES"}>RBI Guidelines</TranslateText>
                    </div>
                    <div>
                        <TranslateText label={"RBI_GUIDELINES_DESCRIPTION"}>As per the new RBI guidelines, we can no longer store your card information with us</TranslateText>.
                    </div>
                    <div className='detail'>
                        <div> <img src="./assets/others/card-lock.svg" alt="icon" /></div>
                        <div>
                            <TranslateText label={"BANK_CARD_SECURITY_DESCRIPTION"}>Your bank/card network will securely save your card information via tokenization if you consent for the same</TranslateText>.
                        </div>
                    </div>
                    <div className='detail'>
                        <div> <img src="./assets/others/card-add.svg" alt="icon" /></div>
                        <div>
                            <TranslateText label={"TOKENIZATION_DESCRIPTION"}>In case you choose to not tokenize, you'll have to enter card details every time you pay</TranslateText>.
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default RbiGuideLineModal;